import { render, staticRenderFns } from "./flyerImageBox.vue?vue&type=template&id=e865b784&"
import script from "./flyerImageBox.vue?vue&type=script&lang=js&"
export * from "./flyerImageBox.vue?vue&type=script&lang=js&"
import style0 from "./flyerImageBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports